import { map } from 'rxjs/operators';
import { Injector, Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { IncorrectPayment } from '../../model/incorrect-payment';
import { IncorrectPaymentCommand } from '../../command/incorrect-payment';
import { PayInvoiceFormComponent } from '../../component/pay-invoice-form/pay-invoice-form.component';
import { Observable } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class PayInvoiceCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindow: ActionWindowService,
    private _injector: Injector,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === IncorrectPaymentCommand.payInvoice && command.context instanceof IncorrectPayment;
    }
    return false;
  }
  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionWindow.open(PayInvoiceFormComponent, this._injector, null, command.context, true).pipe(
        map(result => {
          if (result) {
            (<IncorrectPayment>command.context).balance = result.balance;
            this._navigationService.navigateToList();
          }
        })
      );
    }
  }
}
